import { guards } from '@shared/helpers/typeguards.helpers';
import { SbefCode } from './sbef.model';

/**
 * A custom group of SBEF codes
 *
 */
export class SBEFCustomGroup {
  readonly id: string;
  readonly sbefCodes: SbefCode[];
  readonly sbefCodesSet: Set<SbefCode>;
  readonly description: string;

  constructor(props: {
    sbefCodes: SbefCode[];
    id: string;
    description: string;
  }) {
    this.id = props.id;
    this.sbefCodes = props.sbefCodes;
    this.sbefCodesSet = new Set(props.sbefCodes);
    if (this.sbefCodes.length !== this.sbefCodesSet.size) {
      throw new Error('duplicate sbef codes in custom group');
    }

    this.description = props.description;
  }

  public isPartOfGroup(code: SbefCode | undefined): boolean {
    return guards.is.defined(code) && this.sbefCodesSet.has(code);
  }

  public get label(): string {
    return `${this.id}. ${this.description}`;
  }

  /**
   * Check if a value is a SBEFCodeCustomGroup
   * @param value
   * @returns true if the value is a SBEFCodeCustomGroup
   */
  static is(value: unknown): value is SBEFCustomGroup {
    return value instanceof SBEFCustomGroup;
  }
}
